export const personaHeaderViewProfilebutton = "R780ce";
export default {personaHeaderViewProfilebutton};